// extracted by mini-css-extract-plugin
export var checkboxInputRow = "z_tb";
export var checkboxInputColumn = "z_tc";
export var inputOptionRow = "z_sN";
export var inputOptionColumn = "z_sP";